import React from "react";
import './Blocs.scss';

function BlocSeparateur() {
  return <div className="bloc bloc-separateur">
  </div>;
}
export default BlocSeparateur;
